import _ from 'lodash';
import { LOCATION_CHANGE } from 'react-router-redux';

import {
  HIDE_HEADER_LOCATIONS,
  HIDE_SIDEBAR_LOCATIONS,
} from 'Common/Constants';

import * as types from './types';

const INITIAL_STATE = {
  keyboardActive: false,
  sidebarDisplay: true,
  isSidebarMessagesPanelActive: false,
  sidebarMessages: [],
  uploadProgressDisplay: false,
  uploadProgressTotal: 0,
  uploadProgressCurrent: 0,
  uploadProgressCanceled: false,
  notifications: [],
  headerDisplay: true,
  centerMessagesDisplay: false,
  centerMessagesActive: false,
  centerMessages: [],
  redirectURLData: '',
  cancelProcessError: null,
  fullscreen: false,
  keyboardDisplay: false,
};

const addToList = (list, newElement, newElementId) => {
  var updatedList = _.cloneDeep(list);
  var index = updatedList.findIndex(element => element.Id === newElementId);

  if (index === -1) {
    updatedList.push(newElement);
  } else {
    updatedList[index] = newElement;
  }
  return updatedList;
};

const removeFromList = (list, removeId) => {
  var updatedList = _.cloneDeep(list);
  const index = updatedList.findIndex(element => element.Id === removeId);

  if (index !== -1) {
    updatedList.splice(index, 1);
  }
  return updatedList;
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.UI_KEYBOARD_ACTIVE:
      return { ...state, keyboardActive: true };
    case types.UI_KEYBOARD_INACTIVE:
      return { ...state, keyboardActive: false };
    case types.UI_SIDEBAR_MESSAGES_SHOW:
      return { ...state, isSidebarMessagesPanelActive: true };
    case types.UI_SIDEBAR_MESSAGES_HIDE:
      return { ...state, isSidebarMessagesPanelActive: false };
    case types.UI_SIDEBAR_ADD_MESSAGE:
      return {
        ...state,
        sidebarMessages: addToList(state.sidebarMessages, payload, payload.Id),
      };
    case types.UI_SIDEBAR_REMOVE_MESSAGE:
      return {
        ...state,
        sidebarMessages: removeFromList(state.sidebarMessages, payload),
      };
    case types.UI_SIDEBAR_CLEAR_MESSAGES:
      return { ...state, sidebarMessages: [] };

    case types.UI_CENTER_MESSAGES_SHOW:
      return { ...state, centerMessagesDisplay: true };
    case types.UI_CENTER_MESSAGES_HIDE:
      return { ...state, centerMessagesDisplay: false };
    case types.UI_CENTER_MESSAGES_ACTIVE:
      return { ...state, centerMessagesActive: true };
    case types.UI_CENTER_MESSAGES_INACTIVE:
      return { ...state, centerMessagesActive: false };
    case types.UI_CENTER_ADD_MESSAGE:
      return {
        ...state,
        centerMessagesActive: true,
        centerMessages: addToList(state.centerMessages, payload, payload.Id),
      };
    case types.UI_CENTER_REMOVE_MESSAGE:
      return {
        ...state,
        centerMessages: removeFromList(state.centerMessages, payload),
      };
    case types.UI_CENTER_CLEAR_MESSAGE:
      return { ...state, centerMessages: [] };
    case types.UI_UPLOAD_PROGRESS_SHOW:
      return {
        ...state,
        uploadProgressDisplay: true,
        uploadProgressCanceled: false,
      };
    case types.UI_UPLOAD_PROGRESS_HIDE:
      return {
        ...state,
        uploadProgressDisplay: false,
        uploadProgressCanceled: false,
      };
    case types.UI_UPLOAD_PROGRESS_TOTAL:
      return { ...state, uploadProgressTotal: payload };
    case types.UI_UPLOAD_PROGRESS_CURRENT:
      return { ...state, uploadProgressCurrent: payload };
    case types.UI_RESET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgressDisplay: false,
        uploadProgressTotal: 0,
        uploadProgressCurrent: 0,
        uploadProgressCanceled: false,
      };
    case types.UI_CANCEL_UPLOAD:
      return {
        ...state,
        uploadProgressCanceled: true,
      };

    case types.UI_NOTIFICATION_ADD_MESSAGE:
      return {
        ...state,
        notifications: addToList(state.notifications, payload.Data, payload.Id),
      };
    case types.UI_NOTIFICATION_REMOVE_MESSAGE:
      return {
        ...state,
        notifications: removeFromList(state.notifications, payload),
      };
    case types.UI_NOTIFICATION_INITIALIZE:
      return {
        ...state,
        notifications: _.cloneDeep(payload),
      };
    case types.UI_SIDEBAR_SET_DISPLAY:
      return {
        ...state,
        sidebarDisplay: payload,
      };
    case types.UI_HEADER_SET_DISPLAY:
      return {
        ...state,
        headerDisplay: payload,
      };
    case LOCATION_CHANGE:
      /**
       * On location change, check if the page has sidebar/navbar opened
       */
      const { pathname } = payload;
      const showHeader = !HIDE_HEADER_LOCATIONS.some(location =>
        pathname.includes(location)
      );
      const showSidebar = !HIDE_SIDEBAR_LOCATIONS.some(location =>
        pathname.includes(location)
      );
      return {
        ...state,
        headerDisplay: showHeader,
        sidebarDisplay: showSidebar,
      };
    case types.UI_REDIRECT_URL:
      return {
        ...state,
        redirectURLData: payload,
      };
    case types.UI_CLEAR_REDIRECT_URL:
      return {
        ...state,
        redirectURLData: '',
      };
    case types.UI_CANCEL_PROCESS_ERROR:
      const cancelProcessResponse = payload.response;
      if (
        _.has(
          cancelProcessResponse,
          'data.Errors' &&
            cancelProcessResponse.data.Errors &&
            cancelProcessResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          cancelProcessError: cancelProcessResponse.data.Errors,
        };
      }
      return {
        ...state,
        cancelProcessError: {
          Title: 'Error',
          Message:
            'An error occurred while cancelling process. Please try again',
        },
      };

    case types.UI_FULLSCREEN:
      return {
        ...state,
        fullscreen: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/UI/state/reducer.js